function formatStr (str: string) {
  return str.replace(/\n\s\s+/g, ' ').trim()
}

export const i18n = {
  en: {
    GENERAL: {
      DEFAULT_PICKER_PLACEHOLDER: 'Select an item..',
      COMING_SOON: 'COMING SOON',
      MONTHS: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    },
    MENU: {
      WORK_ORDERS: {
        HEADER: 'WORK ORDERS',
        OPEN_WORK_ORDERS: 'My work orders',
        CREATE_WORK_ORDER: 'Create a new work order',
      },
      SETTINGS: {
        HEADER: 'SETTINGS',
        PROFILE: 'My Profile',
      },
      LOGIN: 'Log in',
      LOGOUT: 'Log out',
    },
    WORK_ORDERS: {
      CREATE: {
        EMAIL_VERIFICATION: {
          HEADER: "LET'S GET STARTED",
          DESCRIPTION: formatStr(`
            We're going to guide you through entering your work order, don't worry it's
            easy and only takes a few minutes to do.
          `),
          NEXT_STEP: 'GET STARTED',
          EMAIL_INPUT_PLACEHOLDER: 'email address',
          DISCLAIMER: 'By continuing "Get Started" you agree to our Terms & Agreements',
        },
        ADD_PHOTOS: {
          HEADER: 'ADD PHOTO',
          DESCRIPTION: formatStr(`
            Photos of your request help us provide accurate proposals
            and allows Spackle to fulfill your work ASAP!
          `),
          TAKE_A_PHOTO: 'Take a Photo',
          CHOOSE_A_PHOTO: 'Choose a Photo',
          TAP_INSTRUCTIONS: 'Tap a Photo to add description',
          CLICK_INSTRUCTIONS: 'Click on a Photo to add description',
          NEXT_STEP: 'Add a Description',
        },
        ADD_DESCRIPTION: {
          HEADER: 'ADD A DESCRIPTION',
          DESCRIPTION: formatStr(`
            What needs to be done? Provide a brief description of your work order and we'll work on the the details.
          `),
          DESCRIPTION_INPUT_PLACEHOLDER: 'Provide a description of the work that needs to be done',
          AFTER_HOURS_LABEL: 'After Hours',
          URGENT_LABEL: 'Urgent',
          URGENT_NOTICE: formatStr(`
            Please note that urgent work order requests have an additional fee associated with them.
          `),
          PREV_STEP: 'Back',
          NEXT_STEP: 'Done',
        },
        THANK_YOU: {
          HEADER: 'THANK YOU!',
          DESCRIPTION: formatStr(`
            Your work ordered has been submitted and we are already sourcing contractors.
          `),
          EMAIL_NOTIFICATION_START: 'An email confirmation has been sent to ',
          EMAIL_NOTIFICATION_MIDDLE: '. You may contact Spackle directly at ',
          EMAIL_NOTIFICATION_END: '',
          NEXT_STEP: 'Create Another Work Order',
        },
      },
      LIST: {
        HEADER: 'Work Orders',
        PENDING_REQUESTS: 'Pending Requests',
        ACTIVE_WORK_ORDERS: 'Active Work Orders',
        SEARCH: {
          BUTTON: 'Search',
          PLACEHOLDER: 'Search...',
          SUBTEXT: 'Search by description, building address, or work order number',
        },
        CARDS: {
          SUBMITTED_ON: 'Submitted on',
          AT: 'at',
          NO_DESCRIPTION: 'No description',
        },
        STATUS: {
          ALL: 'All',
          Draft: 'Draft',
          'In Progress': 'In Progress',
          Active: 'Active',
          'Work Completed': 'Completed',
        },
        CREATE_WORK_ORDER: 'Create Work Order Request',
        LOAD_FAILED: formatStr(`
          Failed to load work orders. Please try again later.
        `),
        NO_WORK_ORDERS: 'No work orders to show',
      },
      VIEW: {
        WORK_ORDER: 'Work Order',
        STATUS: 'Status',
        EST_COMPLETION_DATE: 'Est. Completion Date',
        LOAD_FAILED: formatStr(`
          Failed to load work order. Please try again later.
        `),
        DESCRIPTION: 'Description',
        URGENT: 'Urgent',
        AFTER_HOURS: 'After hours',
        PHOTO: 'photo',
        ATTACHED: 'attached',
        PENDING_HEADER: 'Pending Work Order',
      },
      TASK: {
        WORK_ORDER: 'Work Order',
        NO_DESCRIPTION: 'No description provided',
        LOAD_FAILED: formatStr(`
          Failed to load task. Please try again later.
        `),
      },
    },
    PROFILE: {
      HEADER: 'MY PROFILE',
      ABOUT_ME: {
        HEADER: 'About me',
        FIRST_NAME_PLACEHOLDER: 'First name',
        LAST_NAME_PLACEHOLDER: 'Last name',
        TITLE_PLACEHOLDER: 'Title',
        EMAIL_PLACEHOLDER: 'Email',
        PHONE_PLACEHOLDER: 'Phone',
      },
      MY_BUSINESS: {
        HEADER: 'My business',
        BUSINESS_NAME_PLACEHOLDER: 'Business Name',
        ADDRESS_PLACEHOLDER: 'Address',
        SUITE_PLACEHOLDER: 'Suite/Floor',
        CITY_PLACEHOLDER: 'City',
        STATE_PLACEHOLDER: 'State',
        ZIP_CODE_PLACEHOLDER: 'Zip',
      },
      PREFERENCES: {
        HEADER: 'Preferences',
        PREFERRED_CRAFTSMANSHIP_PLACEHOLDER: 'Preferred level of craftsmanship',
        PRICING_PREFERENCE_PLACEHOLDER: 'Pricing preference',
      },
      SECONDARY_CONTACT: {
        HEADER: 'Secondary Contact',
        FIRST_NAME_PLACEHOLDER: 'First name',
        LAST_NAME_PLACEHOLDER: 'Last name',
        TITLE_PLACEHOLDER: 'Title',
        EMAIL_PLACEHOLDER: 'Email',
        PHONE_PLACEHOLDER: 'Phone',
      },
      PROFILE_UPDATED: {
        HEADER: 'Thank you',
        DESCRIPTION: formatStr(`
          Your profile has been updated!
        `),
        BACK: 'Create a Work Order',
      },
    },
  },
  es: {
    GENERAL: {
      DEFAULT_PICKER_PLACEHOLDER: 'Seleccione una opción..',
      COMING_SOON: 'PRÓXIMAMENTE',
      MONTHS: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    },
    MENU: {
      WORK_ORDERS: {
        HEADER: 'ÓRDENES DE TRABAJO',
        OPEN_WORK_ORDERS: 'Mis órdenes de trabajo',
        CREATE_WORK_ORDER: 'Crear orden de trabajo',
      },
      SETTINGS: {
        HEADER: 'CONFIGURACIÓN',
        PROFILE: 'Mi Perfil',
      },
      LOGIN: 'Iniciar sesión',
      LOGOUT: 'Cerrar sesión',
    },
    WORK_ORDERS: {
      CREATE: {
        EMAIL_VERIFICATION: {
          HEADER: 'COMENCEMOS',
          DESCRIPTION: formatStr(`
            Te guiaremos a través del proceso de ingreso de tu orden de trabajo. No te
            preocupes, es sencillo y solamente lleva unos minutos.
          `),
          NEXT_STEP: 'COMENZAR',
          EMAIL_INPUT_PLACEHOLDER: 'correo electrónico',
          DISCLAIMER: 'Al presionar "Comenzar", aceptas nuestros Términos & Acuerdos',
        },
        ADD_PHOTOS: {
          HEADER: 'AÑADIR FOTO',
          DESCRIPTION: formatStr(`
            Las fotos de tu pedido de trabajo nos ayudan a brindarte estimaciones
            adecuadas de precios, ¡y a que Spackle puede realizar tu trabajo lo antes posible!.
          `),
          TAKE_A_PHOTO: 'Tomar una Foto',
          CHOOSE_A_PHOTO: 'Elegir una Foto',
          TAP_INSTRUCTIONS: 'Toca una Foto para agregar descripción',
          CLICK_INSTRUCTIONS: 'Clickea una Foto para agregar descripción',
          NEXT_STEP: 'Agregar Descripción',
        },
        ADD_DESCRIPTION: {
          HEADER: 'AÑADIR DESCRIPCIÓN',
          DESCRIPTION: formatStr(`
            ¿De qué se trata el trabajo? Escribe una breve descripción de tu orden, y nosotros nos encargaremos de los detalles.
          `),
          AFTER_HOURS_LABEL: 'Después del horario laboral',
          URGENT_LABEL: 'Urgente',
          URGENT_NOTICE: formatStr(`
            Los pedidos de trabajo urgentes tienen un costo adicional asociado.
          `),
          DESCRIPTION_INPUT_PLACEHOLDER: 'Escribe una breve descripción del trabajo a realizar',
          PREV_STEP: 'Volver',
          NEXT_STEP: 'Listo',
        },
        THANK_YOU: {
          HEADER: 'GRACIAS!',
          DESCRIPTION: formatStr(`
            Tu orden de trabajo ha sido enviada, y ya estamos buscando contratistas.
          `),
          EMAIL_NOTIFICATION_START: 'Un email de confirmación ha sido enviado a ',
          EMAIL_NOTIFICATION_MIDDLE: '. Puedes contactarte directamente con Spackle en ',
          EMAIL_NOTIFICATION_END: '',
          NEXT_STEP: 'Create Another Work Order',
        },
      },
      LIST: {
        HEADER: 'Órdenes de Trabajo',
        PENDING_REQUESTS: 'Solicitudes Pendientes',
        ACTIVE_WORK_ORDERS: 'Órdenes de Trabajo Activas',
        SEARCH: {
          BUTTON: 'Buscar',
          PLACEHOLDER: 'Buscar...',
          SUBTEXT: 'Buscar por descriptción, dirección, o número de orden de trabajo',
        },
        CARDS: {
          SUBMITTED_ON: 'Enviada el',
          AT: 'a las',
          NO_DESCRIPTION: 'Sin descripción',
        },
        STATUS: {
          ALL: 'Todas',
          Draft: 'Boceto',
          'In Progress': 'En Progreso',
          Active: 'Activa',
          'Work Completed': 'Completada',
        },
        CREATE_WORK_ORDER: 'Nueva Orden de Trabajo',
        LOAD_FAILED: formatStr(`
          Error al cargar órdenes de trabajo. Por favor, reintentar más tarde.
        `),
        NO_WORK_ORDERS: 'No hay órdenes de trabajo para mostrar',
      },
      VIEW: {
        WORK_ORDER: 'Orden de Trabajo',
        STATUS: 'Estado',
        EST_COMPLETION_DATE: 'Fecha est. de finalización',
        LOAD_FAILED: formatStr(`
          Error al cargar orden de trabajo. Por favor, reintentar más tarde.
        `),
        DESCRIPTION: 'Descripción',
        URGENT: 'Urgente',
        AFTER_HOURS: 'Después de horario laboral',
        PHOTO: 'foto',
        ATTACHED: 'adjunta',
        PENDING_HEADER: 'Órden de Trabajo Pendiente',
      },
      TASK: {
        WORK_ORDER: 'Orden de Trabajo',
        NO_DESCRIPTION: 'No hay descripción',
        LOAD_FAILED: formatStr(`
        Error al cargar tarea. Por favor, reintentar más tarde.
        `),
      },
    },
    PROFILE: {
      HEADER: 'MI PERFIL',
      ABOUT_ME: {
        HEADER: 'Sobre mi',
        FIRST_NAME_PLACEHOLDER: 'Nombre',
        LAST_NAME_PLACEHOLDER: 'Apellido',
        TITLE_PLACEHOLDER: 'Título',
        EMAIL_PLACEHOLDER: 'Correo electrónico',
        PHONE_PLACEHOLDER: 'Teléfono',
      },
      MY_BUSINESS: {
        HEADER: 'Mi negocio',
        BUSINESS_NAME_PLACEHOLDER: 'Nombre del negocio',
        ADDRESS_PLACEHOLDER: 'Dirección',
        SUITE_PLACEHOLDER: 'Apartamento/Piso',
        CITY_PLACEHOLDER: 'Ciudad',
        STATE_PLACEHOLDER: 'Estado',
        ZIP_CODE_PLACEHOLDER: 'Zip',
      },
      PREFERENCES: {
        HEADER: 'Preferencias',
        PREFERRED_CRAFTSMANSHIP_PLACEHOLDER: 'Nivel de artesanía preferido',
        PRICING_PREFERENCE_PLACEHOLDER: 'Preferencia de precios',
      },
      SECONDARY_CONTACT: {
        HEADER: 'Contacto Secundario',
        FIRST_NAME_PLACEHOLDER: 'Nombre',
        LAST_NAME_PLACEHOLDER: 'Apellido',
        TITLE_PLACEHOLDER: 'Título',
        EMAIL_PLACEHOLDER: 'Correo electrónico',
        PHONE_PLACEHOLDER: 'Teléfono',
      },
      PROFILE_UPDATED: {
        HEADER: 'Gracias',
        DESCRIPTION: formatStr(`
          ¡Tu perfil ha sido actualizado!
        `),
        BACK: 'Crear una Orden de Trabajo',
      },
    },
  },
  de: {
    GENERAL: {
      DEFAULT_PICKER_PLACEHOLDER: 'Wählen Sie ein Element',
      COMING_SOON: 'KOMMT BALD',
      MONTHS: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    },
    MENU: {
      WORK_ORDERS: {
        HEADER: 'ARBEITSAUFTRÄGE',
        OPEN_WORK_ORDERS: 'Meine offenen Arbeitsaufträge',
        CREATE_WORK_ORDER: 'Einen neuen Arbeitsauftrag erstellen',
      },
      SETTINGS: {
        HEADER: 'EINSTELLUNGEN',
        PROFILE: 'Mein Profil',
      },
      LOGIN: 'Einloggen',
      LOGOUT: 'Ausloggen',
    },
    WORK_ORDERS: {
      CREATE: {
        EMAIL_VERIFICATION: {
          HEADER: 'LASS UNS ANFANGEN',
          DESCRIPTION: formatStr(`
            Wir werden Sie durch die Eingabe Ihres Arbeitsauftrags führen, keine Sorge, es ist
            einfach und dauert nur wenige Minuten.
          `),
          NEXT_STEP: 'LOSLEGEN',
          EMAIL_INPUT_PLACEHOLDER: 'e-mail-addresse',
          DISCLAIMER: formatStr(`
            Indem Sie mit "Erste Schritte" fortfahren, stimmen Sie unseren Allgemeinen Geschäftsbedingungen zu'
          `),
        },
        ADD_PHOTOS: {
          HEADER: 'FOTO HINZUFÜGEN',
          DESCRIPTION: formatStr(`
            Fotos Ihrer Arbeitsanfrage helfen uns wirklich, genaue Schätzungen zu erstellen
            und erhalten Sie Dienstleister, um Ihre Arbeit so schnell wie möglich zu erfüllen!
          `),
          TAKE_A_PHOTO: 'Mach ein Foto',
          CHOOSE_A_PHOTO: 'Wählen ein Foto',
          TAP_INSTRUCTIONS: 'Tippen ein Foto, um eine Beschreibung hinzuzufügen',
          CLICK_INSTRUCTIONS: 'Klicken ein Foto, um eine Beschreibung hinzuzufügen',
          NEXT_STEP: 'Beschreibung hinzufügen',
        },
        ADD_DESCRIPTION: {
          HEADER: 'BESCHREIBUNG HINZUFÜGEN',
          DESCRIPTION: formatStr(`
            Was getan werden muss? Geben Sie eine kurze Beschreibung Ihres Arbeitsauftrags und wir arbeiten an den Details.
          `),
          AFTER_HOURS_LABEL: 'Nach Geschäftsschluss',
          URGENT_LABEL: 'Dringend',
          URGENT_NOTICE: formatStr(`
            Bitte beachten Sie, dass mit dringenden Produktionsauftragsanträgen eine zusätzliche Gebühr verbunden ist.
          `),
          DESCRIPTION_INPUT_PLACEHOLDER: 'Geben Sie eine Beschreibung der zu erledigenden Arbeiten an',
          PREV_STEP: 'Zurück',
          NEXT_STEP: 'Wähle Optionen',
        },
        THANK_YOU: {
          HEADER: 'DANKE SCHÖN!',
          DESCRIPTION: formatStr(`
            Ihre bestellte Arbeit wurde eingereicht und wir beschaffen bereits Vertragspartner.
          `),
          EMAIL_NOTIFICATION_START: 'Eine E-Mail-Bestätigung wurde an ',
          EMAIL_NOTIFICATION_MIDDLE: ' gesendet. Sie können Spackle direkt unter ',
          EMAIL_NOTIFICATION_END: ' kontaktieren',
          NEXT_STEP: 'Erstellen Sie einen weiteren Produktionsauftrag',
        },
      },
      LIST: {
        HEADER: 'Produktionsauftrag',
        PENDING_REQUESTS: 'Ausstehenden Anforderungen',
        ACTIVE_WORK_ORDERS: 'Aktive Produktionsauftrag',
        SEARCH: {
          BUTTON: 'Such',
          PLACEHOLDER: 'Such...',
          SUBTEXT: 'Suche nach Beschreibung, Gebäudeadresse oder Produktionsauftragsnummer',
        },
        CARDS: {
          SUBMITTED_ON: 'Submitted on',
          AT: 'at',
          NO_DESCRIPTION: 'No description',
        },
        STATUS: {
          ALL: 'All',
          Draft: 'Draft',
          'In Progress': 'In Progress',
          Active: 'Active',
          'Work Completed': 'Completed',
        },
        CREATE_WORK_ORDER: 'Create Work Order Request',
        LOAD_FAILED: formatStr(`
          Failed to load work orders. Please try again later.
        `),
        NO_WORK_ORDERS: 'No work orders to show',
      },
      VIEW: {
        WORK_ORDER: 'Work Order',
        STATUS: 'Status',
        EST_COMPLETION_DATE: 'Est. Completion Date',
        LOAD_FAILED: formatStr(`
          Failed to load work order. Please try again later.
        `),
        DESCRIPTION: 'Description',
        URGENT: 'Urgent',
        AFTER_HOURS: 'After hours',
        PHOTO: 'photo',
        ATTACHED: 'attached',
        PENDING_HEADER: 'Ausstehender Arbeitsauftrag',
      },
      TASK: {
        WORK_ORDER: 'Work Order',
        NO_DESCRIPTION: 'No description provided',
        LOAD_FAILED: formatStr(`
          Failed to load task. Please try again later.
        `),
      },
    },
    PROFILE: {
      HEADER: 'MEIN PROFIL',
      ABOUT_ME: {
        HEADER: 'Von mir',
        FIRST_NAME_PLACEHOLDER: 'Vorname',
        LAST_NAME_PLACEHOLDER: 'Familienname',
        TITLE_PLACEHOLDER: 'Titel',
        EMAIL_PLACEHOLDER: 'E-mail',
        PHONE_PLACEHOLDER: 'Rufnummer',
      },
      MY_BUSINESS: {
        HEADER: 'Mein Geschäft',
        BUSINESS_NAME_PLACEHOLDER: 'Firmenname',
        ADDRESS_PLACEHOLDER: 'Anschrift',
        SUITE_PLACEHOLDER: 'Suite/Etage',
        CITY_PLACEHOLDER: 'Stadt',
        STATE_PLACEHOLDER: 'Staat',
        ZIP_CODE_PLACEHOLDER: 'Zip',
      },
      PREFERENCES: {
        HEADER: 'Einstellungen',
        PREFERRED_CRAFTSMANSHIP_PLACEHOLDER: 'Bevorzugtes Maß an Handwerkskunst',
        PRICING_PREFERENCE_PLACEHOLDER: 'Preispräferenz',
      },
      SECONDARY_CONTACT: {
        HEADER: 'Zweiten Kontakt',
        FIRST_NAME_PLACEHOLDER: 'Vorname',
        LAST_NAME_PLACEHOLDER: 'Familienname',
        TITLE_PLACEHOLDER: 'Titel',
        EMAIL_PLACEHOLDER: 'E-mail',
        PHONE_PLACEHOLDER: 'Rufnummer',
      },
      PROFILE_UPDATED: {
        HEADER: 'Danke Schön',
        DESCRIPTION: formatStr(`
          Ihr Profil wurde aktualisiert!
        `),
        BACK: 'Erstellen Sie einen Produktionsauftrag',
      },
    },
  },
}
